var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-input',{attrs:{"error-messages":_vm.errorMessages,"maxlength":"500"}},[_c('tiptap-vuetify',{class:`text-tr ${_vm.errorMessages.length > 0 ? 'error-tr' : ''}`,attrs:{"extensions":_vm.extensions,"placeholder":_vm.placeholder,"value":_vm.value},on:{"input":_vm.handleContentChange,"blur":function($event){return _vm.$emit('blur')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }